import React, { useState } from "react";
import { fetchData } from "../../networkRequests";
import {
  Button,
  Input
} from "reactstrap";
import { focusOnElemName } from "../../../../pages/commonFunctions";



export const UserPassLogin = ({ options, setmessage, handleLogin, forcereset }) => {

  let { username, password, renewpass, newpass, strokes, setusername, setpassword, setnewpass, setrenewpass, setstrokes } = options;
  // let strokes = []; let cnt = 0; let prev;
  // for (var key in state) {
  //   if (key.indexOf("stroke_") != -1) {
  //     if (cnt == 0) {
  //       prev = parseInt(key.split("stroke_")[1]);
  //     } else {
  //       strokes.push(parseInt(key.split("stroke_")[1]) - prev);
  //       prev = parseInt(key.split("stroke_")[1]);
  //     }
  //     cnt += 1;
  //   }
  // }


  const goToElemWithWarning = (e, elemname) => {
    if (e.getModifierState("CapsLock")) {
      setmessage("caps lock is on.")
    } else {
      setmessage("")
    }

    if (e.key === 'Enter') {
      if (!username) {
        setmessage("enter username");
        return false;
      }
      // get current name. Find next name. Focus on that.
      focusOnElemName(elemname);
    }
  }

  const goToLogin = (e) => {
    if (e.getModifierState("CapsLock")) {
      setmessage("caps lock is on.")
    } else {
      setmessage("")
    }
    if (e.key === 'Enter') {
      if (!username) {
        setmessage("enter password");
      }
      handleLogin();
    }
  }


  return (
    <span>
      <div className="col-sm-12">
        <Input
          autoComplete="off"
          placeholder="Login ID"
          name="loginid"
          onChange={e => setusername(e.target.value)}
          style={{ marginTop: 10 }}
          type="text"
          autoFocus="autofocus"
          value={username}
          onKeyDown={(e) => goToElemWithWarning(e, 'passcode')}
        // onKeyPress={(event) => this.handleKeyPress('password', event)}
        />
      </div>
      <div style={{ textAlign: "right", height: 10, color: "#990000", fontSize: 10, paddingTop: 3 }} id="caps-lock-message"></div>
      {!forcereset &&
        <div className="col-sm-12">
          <Input
            className="txtPassword"
            autoComplete="new-password"
            placeholder="Password"
            name="passcode"
            autoComplete="off"
            onChange={e => setpassword(e.target.value)}
            type="text"
            onKeyDown={goToLogin}
            value={password}
          />
        </div>
      }


      {forcereset &&
        <div className="col-sm-12 login_text_box">
          <Input
            className="txtPassword"
            autoComplete="new-password"
            placeholder="OLD Password"
            name="passcode"
            autoComplete="false"
            onChange={e => setpassword(e.target.value)}
            type="text"
            value={password}
            onKeyDown={(e) => goToElemWithWarning(e, 'newpasscode')}
          />
        </div>
      }

      {forcereset &&
        <div className="col-sm-12 login_text_box">
          <Input
            id="resetnew-password"
            className="txtPassword"
            placeholder="NEW Password"
            autoComplete="resetnew-password"
            name="newpasscode"
            autoComplete="false"
            onChange={e => setnewpass(e.target.value)}
            type="text"
            value={newpass}
            onKeyDown={(e) => goToElemWithWarning(e, 'retypenewpasscode')}
          />
        </div>
      }

      {forcereset &&
        <div className="col-sm-12 login_text_box">
          <Input
            className="txtPassword"
            placeholder="Re type NEW Password"
            autoComplete="renew-password"
            name="retypenewpasscode"
            autoComplete="false"
            onChange={e => setrenewpass(e.target.value)}
            type="text"
            onKeyDown={goToLogin}
            value={renewpass}
          />
        </div>
      }



    </span>

  )
}